
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { MAJOR_CITIES, getCityUrl } from '../data/MetauxNonFerreuxData';

const MetauxNonFerreuxCities = () => {
  return (
    <div className="bg-white p-8 rounded-lg shadow-md mb-12">
      <h2 className="text-2xl font-bold text-fabre-gray mb-6">
        Nos Services de Recyclage des Métaux Non Ferreux par Ville
      </h2>
      
      <p className="mb-6 text-gray-700">
        Le Groupe Fabre Environnement intervient dans les principales villes et communes pour 
        la collecte et le recyclage des métaux non ferreux. Nos équipes locales assurent un service 
        de proximité adapté à vos besoins.
      </p>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 mt-6">
        {MAJOR_CITIES.map((city) => (
          <div key={city.name} className="text-center">
            <Link 
              to={getCityUrl(city.name)}
              className="block p-4 rounded-md bg-fabre-lightgreen hover:bg-fabre-green/20 transition-colors"
            >
              <span className="text-fabre-darkgreen font-medium">{city.name}</span>
            </Link>
          </div>
        ))}
      </div>
      
      <div className="mt-8 text-center">
        <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
          <Link to="/contact">
            Demander un devis
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default MetauxNonFerreuxCities;
